<template>
  <div>
    <div class="main-content">
      <div>
        <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
      </div>
      <div class="public-table">
        <vxe-grid
          border="outer"
          show-overflow
          resizable
          ref="standard"
          height="300"
          class="vxe-table-element"
          size="mini"
          align="left"
          :auto-resize="true"
          :data="eventData"
          :columns="linkColumnList"
          :toolbar="{}"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          :valid-config="{ autoPos: true, message: 'inline' }"
        >
        </vxe-grid>
      </div>
    </div>
  </div>
</template>

<script>
  // import inputRange from './components/input-range';
  // import inputQuota from './components/input-quota';
  import { mapState } from 'vuex';
  import buttonItem from '../../../../components/ButtonItem';
  export default {
    name: 'gradeStandard',
    components: {
      // inputRange,
      // inputQuota,
      buttonItem,
    },
    mounted() {
      this.$axios
        .post('/maindata/dictData/listDataDictByDataType', { dictType: 'LevelStandard_LEVEL' })
        .then((res) => {
          this.standardList = res.data.data;
        });
      this.$axios
        .post('/maindata/dictData/listDataDictByDataType', {
          dictType: 'LevelStandard_RATIO_OBJECT',
        })
        .then((res) => {
          this.scaleObjectList = res.data.data;
        });
      this.getButtonList();
      this.getData();
    },
    data() {
      return {
        startScore: 0,
        endScore: 0,
        standardList: [],
        eventData: [],
        quotaTypeList: [
          { label: '定额', value: 'quota' },
          { label: '比例', value: 'ratio' },
        ],
        scaleObjectList: [],
        menuButtonList: [],
      };
    },
    computed: {
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', visible: true, width: '80' },
          {
            field: 'level',
            title: '评级',
            editRender: {
              name: 'ElSelect',
              props: { clearable: true },
              options: this.standardList,
            },
            width: '180',
          },
          {
            title: '评分',
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    [{row.startScore} , {this.formatterSection(row.endScore)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-range
                    startScore={row.startScore}
                    endScore={row.endScore}
                    onInput={(val) => this.scoreInput(val, row)}
                  ></input-range>,
                ];
              },
            },
          },
          {
            field: 'quotaType',
            title: '定额/比例',
            editRender: {
              name: 'ElSelect',
              props: { clearable: true },
              options: this.quotaTypeList,
              events: { change: (obj) => this.changeQuotaType(obj) },
            },
            width: '180',
          },
          {
            title: '授信额度(万)',
            editRender: { name: 'inputQuota', type: 'default' },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.formatCreditLine(row)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-quota
                    quotaType={row.quotaType}
                    creditLine={row.creditLine}
                    ratioObjectType={row.ratioObjectType}
                    ratio={row.ratio}
                    options={this.scaleObjectList}
                    onInput={(val) => this.creditLineInput(val, row)}
                    onSelect={(val) => this.creditLineSelect(val, row)}
                  ></input-quota>,
                ];
              },
            },
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    methods: {
      changeQuotaType({ row }) {
        //定额比例同意
        this.eventData.forEach((item) => {
          item.quotaType = row.quotaType;
        });
      },
      getData() {
        this.$axios.post('/sales/creditLimitEngineStandard/list').then((res) => {
          this.eventData = res.data.data;
        });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e);
          this.menuButtonList = e;
        });
      },
      clickEvent(type) {
        if (type === 'add') {
          this.add();
        } else if (type === 'delete') {
          this.remove('standard');
        } else if (type === 'save') {
          this.save();
        }
      },
      add() {
        let current = this.$refs.standard.getTableData().fullData.length; //当前表格数据条数
        if (current >= this.standardList.length) {
          this.$message({
            showClose: true,
            type: 'error',
            message: `最大新增${this.standardList.length}条`,
          });
          return;
        }
        //新增一条数据并赋上初始值
        let data = this.$refs.standard.getTableData().fullData;
        data.push({
          startScore: 0,
          endScore: 0,
          quotaType: this.eventData[0].quotaType,
          ratioObjectType: this.eventData[0].ratioObjectType,
          ratioObjectTypeName: this.eventData[0].ratioObjectTypeName,
        });
        this.eventData = data;
      },
      save() {
        let params = this.$refs.standard.getTableData().fullData;
        this.$axios.post('/sales/creditLimitEngineStandard/save', params).then((res) => {
          if (res.data.code === 0) {
            this.$message({ showClose: true, type: 'success', message: '保存成功' });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      remove(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$refs[tableTpye].removeSelecteds();
      },
      scoreInput(val, row) {
        row[val.type] = Number(val.value);
      },
      creditLineInput(val, row) {
        row.creditLine = Number(val);
        row.creditLineName = val;
      },
      creditLineSelect(val, row) {
        // row.creditLineName = this.filter(val.ratioObjectType, this.scaleObjectList) + 'x' + val.proportion + '%'
        //选择比例时比例对象需统一
        this.eventData.forEach((item) => {
          item.ratioObjectType = val.ratioObjectType;
          item.ratioObjectTypeName = this.filter(val.ratioObjectType, this.scaleObjectList);
        });
        row.ratio = Number(val.proportion);
      },
      filter(key, list) {
        let name = '';
        list.map((item) => {
          if (item.value === key) {
            return (name = item.label);
          }
        });
        return name;
      },
      formatterSection(val) {
        let text = '';
        if (val === 100) {
          text = val + ']';
        } else {
          text = val + ')';
        }
        return text;
      },
      //格式化授信额度
      formatCreditLine(row) {
        if (row.quotaType === 'ratio') {
          if (row.ratio) {
            row.creditLineName =
              this.filter(row.ratioObjectType, this.scaleObjectList) + 'x' + row.ratio + '%';
          } else {
            row.creditLineName = '';
          }
        } else {
          row.creditLineName = row.creditLine;
        }
        return row.creditLineName;
      },
    },
  };
</script>

<style scoped></style>
